export { default as GoogleMapsOverlay } from './google-maps-overlay';
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./~/@deck.gl/google-maps/dist/esm/index.js